// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".binding-mfa-modal .el-dialog {\n  width: 980px;\n  border-radius: 16px;\n}", ""]);
// Exports
module.exports = exports;
